<template>
  <v-container fluid class="full-screen">
    <v-btn 
      color="red" 
      class="close-button"
      @click="voltar"
    >
      Voltar
    </v-btn>
    
    <iframe 
      class="bi-frame"
      :src="iframeSrc" 
      frameborder="0"
      allowfullscreen
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    ></iframe>
  </v-container>
</template>
<script>
export default {
  computed: {
    iframeSrc() {
      // console.log('AMBIENTE: '+process.env.NODE_ENV);
      return process.env.NODE_ENV === "development"
        ? "https://localhost:5173/"
        : "https://roleta.higienizacaodasmaos.com/";
    }
  },
  methods: {
    voltar() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        this.$emit('fecharRelatorio');
      }
    }
  }
};
</script>

<style scoped>
.full-screen {
  position: relative; /* Adicionado para que os elementos absolutos se posicionem relativamente a este container */
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: black;
}

.bi-frame {
  width: 100%;
  height: 100%;
  border: none;
}

.close-button {
  position: absolute;
  bottom: 20px;  /* Fica na base do container */
  left: 50%;     /* Centraliza horizontalmente */
  transform: translateX(-50%);
  z-index: 100;
}
</style>